/* eslint-disable no-param-reassign */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { END } from 'redux-saga';
import { getIsClient } from '../../utils';
export var enrichStore = function (_a) {
    var rootReducersPackage = _a.rootReducersPackage, asyncReducersPackage = _a.asyncReducersPackage, sagaMiddleware = _a.sagaMiddleware, store = _a.store, router = _a.router, initialState = _a.initialState, rootSaga = _a.rootSaga, dependencies = _a.dependencies, addMiddleware = _a.addMiddleware, injectSlices = _a.injectSlices;
    // передаём зависимости
    store.dependencies = dependencies;
    // определяем сеттер зависимостей стора
    store.setDependencies = function (newDependencies) {
        store.dependencies = __assign(__assign({}, store.dependencies), newDependencies);
    };
    // определяем геттер зависимостей стора
    store.getDependencies = function () { return store.dependencies || {}; };
    var isNode = !getIsClient();
    store.addMiddleware = addMiddleware;
    store.injectSlices = injectSlices;
    // прокидываем роутер в стор
    store.router = router;
    // создаем регистр динамических  редюсеров
    store.asyncReducers = __assign({}, asyncReducersPackage);
    // создаем регистр root редюсеров
    store.rootReducers = __assign({}, rootReducersPackage);
    // создаем регистр динамических саг
    store.asyncSagas = {};
    // создаем регистр root саг
    store.rootSagas = {};
    // определяем раннер миддливары внутри стора
    store.sagaMiddleware = sagaMiddleware;
    // Функция при вызове которой redux-saga собирает все саги
    // и их результаты и завершает прослушивание всех запущенных саг (через fork!)
    store.closeSagas = function () { return store.dispatch(END); };
    // задаем весь начальный стейт
    store.initialState = initialState;
    // для возможности при инициализации на сервере сделать
    // const sagaRunner = store.sagaMiddleware.run(store.rootSaga);
    // sagaRunner.toPromise().then(() => { renderAppAndSendToClient here })
    if (isNode) {
        store.rootSaga = rootSaga;
    }
};
